var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0039 11.0039H12.9961V4.99611C12.9961 4.44825 12.5479 4 12 4C11.4521 4 11.0039 4.44825 11.0039 4.99611V11.0039H4.99611C4.44825 11.0039 4 11.4521 4 12C4 12.2739 4.11206 12.523 4.29261 12.7035C4.47315 12.884 4.72218 12.9961 4.99611 12.9961H11.0039V19.0039C11.0039 19.2778 11.116 19.5268 11.2965 19.7074C11.477 19.8879 11.7261 20 12 20C12.5479 20 12.9961 19.5518 12.9961 19.0039V12.9961H19.0039C19.5518 12.9961 20 12.5479 20 12C20 11.4521 19.5518 11.0039 19.0039 11.0039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.dfcc0b73255cb900453168cf963b346f.svg";
export { ForwardRef as ReactComponent };